import _ from 'lodash'

export const getNewValue = (response) => {
  return response.NewCellValue
}
export const getSuccess = (response) => {
  return response.Success
}
export const getError = (response) => {
  return response.Error
}

export const getClearCell = (selectedRange) => {
  return {
    selectedCol: selectedRange.selectedCol,
    selectedRow: selectedRange.selectedRow
  }
}

export const getClearCells = (selectedRange) => {
  const leftCol = Math.min(selectedRange.col, selectedRange.col2)
  const rightCol = Math.max(selectedRange.col, selectedRange.col2)
  const selectedCol = selectedRange.selectedCol
  const selectedRow = selectedRange.selectedRow
  const selectedRows = _.range(selectedRange.topRow, selectedRange.bottomRow + 1) // adding 1 becasue the end param in range is exclusive
  const selectedColumns = _.range(leftCol, rightCol + 1)

  return {
    selectedCol,
    selectedRow,
    selectedColumns,
    selectedRows
  }
}

export const getClearCellNewValue = (response) => {
  return response.CellValues[0].NewCellValue
}

export const getClearCellError = (response) => {
  return response.CellValues[0].Error
}

export default {
  getNewValue,
  getSuccess,
  getError,
  getClearCell,
  getClearCells,
  getClearCellNewValue,
  getClearCellError
}
